// Editor Mode's bottom bar ("BrandingBar") glass-panel chrome and screen
// position — see apps/hub/src/modules/core/dashboard/components/EditorMode/styles.ts.
// Shared by every tutorial overlay anchored to that same spot (step text,
// completion notice) so they always stay visually and positionally in sync.
const PANEL_BG =
  'linear-gradient(135deg, rgba(28, 28, 34, 0.88) 0%, rgba(16, 16, 20, 0.88) 100%)';
const PANEL_BORDER = '1px solid rgba(255, 255, 255, 0.08)';
const PANEL_RADIUS = '14px';
const PANEL_BLUR = 'blur(18px)';

/**
 * Positioning + glass-panel chrome shared by tutorial overlays anchored at
 * the Editor Mode bottom bar's screen position.
 */
export const useBottomPanelStyles = () => {
  return {
    root: {
      position: 'fixed',
      bottom: '100px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      width: 'fit-content',
      maxWidth: 'calc(100vw - 48px)',
    },
    panel: {
      background: PANEL_BG,
      border: PANEL_BORDER,
      borderRadius: PANEL_RADIUS,
      backdropFilter: PANEL_BLUR,
      boxShadow: '0 14px 40px rgba(0, 0, 0, 0.35)',
      padding: '12px 14px',
    },
  };
};
